(() => {
  const months = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
  async function setup(root) {
    if (root.dataset.archiveReady) return;
    root.dataset.archiveReady = 'true';
    const details = root.querySelector('details');
    const narrow = matchMedia('(max-width: 749px)');
    const adapt = () => { details.open = !narrow.matches; };
    adapt(); narrow.addEventListener('change', adapt);
    const grid = root.querySelector('[data-archive-grid]');
    const nav = root.querySelector('[data-archive-nav]');
    const status = root.querySelector('[data-archive-status]');
    const cards = new Map([...grid.children].filter(e => e.matches('[data-archive-card]')).map(e => [e.id, e]));
    // Every fetched card is also reachable through normal server-rendered pagination.
    // Keep that navigation intact if any page cannot be loaded.
    try {
      let next = root.querySelector('[data-archive-next]')?.href;
      const seen = new Set();
      if (new URL(location.href).searchParams.has('page')) next = root.dataset.blogUrl;
      while (next) {
        const url = new URL(next, location.origin);
        if (url.origin !== location.origin || seen.has(url.href)) throw new Error('Invalid pagination');
        seen.add(url.href);
        const response = await fetch(url, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Page unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const section = doc.querySelector('[data-hikari-archive]');
        if (!section) throw new Error('Missing archive');
        section.querySelectorAll('[data-archive-card]').forEach(card => { if (!cards.has(card.id)) cards.set(card.id, card); });
        next = section.querySelector('[data-archive-next]')?.getAttribute('href');
      }
      if (cards.size !== Number(root.dataset.total)) throw new Error('Incomplete archive');
      const ordered = [...cards.values()].sort((a,b) => Number(b.dataset.published) - Number(a.dataset.published));
      grid.replaceChildren(...ordered);
      const all = document.createElement('a');
      all.href = root.dataset.blogUrl; all.textContent = 'Todos los artículos'; all.dataset.archiveAll = '';
      nav.replaceChildren(all);
      let year = '', list;
      const monthKeys = new Set();
      ordered.forEach(card => {
        const key = card.dataset.month;
        if (monthKeys.has(key)) return;
        monthKeys.add(key);
        if (year !== key.slice(0,4)) {
          year = key.slice(0,4);
          const heading = document.createElement('h2'); heading.className = 'hikari-archive__year'; const yearLink = document.createElement('a'); yearLink.textContent = year; yearLink.href = '#archivo-' + year; yearLink.dataset.archiveYear = year; heading.append(yearLink);
          list = document.createElement('ul'); nav.append(heading, list);
        }
        const li = document.createElement('li'), link = document.createElement('a');
        link.href = '#archivo-' + key; link.dataset.archiveMonth = key; link.textContent = months[Number(key.slice(5)) - 1];
        li.append(link); list.append(li);
      });
      root.querySelector('[data-archive-pagination]')?.setAttribute('hidden','');
      const filter = key => {
        const isYear = /^\d{4}$/.test(key) && ordered.some(card => card.dataset.month.startsWith(key + '-'));
        if (!monthKeys.has(key) && !isYear) key = '';
        let count = 0;
        ordered.forEach(card => { card.hidden = !!key && !(isYear ? card.dataset.month.startsWith(key + '-') : card.dataset.month === key); if (!card.hidden) count++; });
        nav.querySelectorAll('a').forEach(a => { if ((a.dataset.archiveMonth || a.dataset.archiveYear || '') === key) a.setAttribute('aria-current','true'); else a.removeAttribute('aria-current'); });
        status.textContent = (isYear ? key : key ? months[Number(key.slice(5))-1] + ' de ' + key.slice(0,4) : 'Todos los artículos') + ' · ' + count;
      };
      nav.addEventListener('click', e => {
        const link = e.target.closest('a'); if (!link || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        const key = link.dataset.archiveMonth || link.dataset.archiveYear || '';
        history.replaceState(null, '', key ? '#archivo-' + key : location.pathname + location.search);
        filter(key); // Keep the accordion open so focus remains on the chosen link.
      });
      window.addEventListener('hashchange', () => filter(location.hash.replace('#archivo-','')));
      filter(location.hash.replace('#archivo-',''));
    } catch (_) {
      status.textContent = 'Consulta los artículos y las fechas de esta página. Usa la paginación para ver más.';
    }
  }
  document.querySelectorAll('[data-hikari-archive]').forEach(setup);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-hikari-archive]').forEach(setup));
})();
